import styled from 'styled-components';
import { spacing } from '_utils/props';

export const RatesInputSection = styled.div`
  ${({ theme }) => spacing({ theme, $mt: 8 })}
`;
export const RatesCalculationSection = styled.div`
  ${({ theme }) => spacing({ theme, $mt: 7 })}
`;
